/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Milliman.PullThroughPortal.WebAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
  ErrorResponse,
  ErrorResponseFromJSON,
  ErrorResponseFromJSONTyped,
  ErrorResponseToJSON,
  Message,
  MessageFromJSON,
  MessageFromJSONTyped,
  MessageToJSON,
} from "./";

/**
 *
 * @export
 * @interface MessageIEnumerableControllerResponse
 */
export interface MessageIEnumerableControllerResponse {
  /**
   *
   * @type {Array<Message>}
   * @memberof MessageIEnumerableControllerResponse
   */
  data?: Array<Message> | null;
  /**
   *
   * @type {ErrorResponse}
   * @memberof MessageIEnumerableControllerResponse
   */
  error?: ErrorResponse;
}

export function MessageIEnumerableControllerResponseFromJSON(json: any): MessageIEnumerableControllerResponse {
  return MessageIEnumerableControllerResponseFromJSONTyped(json, false);
}

export function MessageIEnumerableControllerResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): MessageIEnumerableControllerResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    data: !exists(json, "data")
      ? undefined
      : json["data"] === null
        ? null
        : (json["data"] as Array<any>).map(MessageFromJSON),
    error: !exists(json, "error") ? undefined : ErrorResponseFromJSON(json["error"]),
  };
}

export function MessageIEnumerableControllerResponseToJSON(value?: MessageIEnumerableControllerResponse | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    data:
      value.data === undefined ? undefined : value.data === null ? null : (value.data as Array<any>).map(MessageToJSON),
    error: ErrorResponseToJSON(value.error),
  };
}
